/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { QualityGateEntry } from '../models/quality-gate-entry';
import { QualityGateFilter } from '../models/quality-gate-filter';
import { QualityGateEntryDetails } from '../models/quality-gate-entry-details';
import { QualityGateDetailsFilter } from '../models/quality-gate-details-filter';
import { StatusDetail } from '../models/status-detail';
import { QualityGateSubmission } from '../models/quality-gate-submission';
import { QualityGateMultiSubmission } from '../models/quality-gate-multi-submission';
@Injectable({
  providedIn: 'root',
})
class QualityGateService extends __BaseService {
  static readonly syncQgDataPath = '/qualityGate/syncData';
  static readonly viewPath = '/qualityGate/view';
  static readonly viewEntryDetailsPath = '/qualityGate/view/details';
  static readonly submitPath = '/qualityGate/submit';
  static readonly multiSubmissionPath = '/qualityGate/multi-submission';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return it will return true or false weather QG sync successfully or not.
   */
  syncQgDataResponse(): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/qualityGate/syncData`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @return it will return true or false weather QG sync successfully or not.
   */
  syncQgData(): __Observable<boolean> {
    return this.syncQgDataResponse().pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param filter undefined
   * @return getQualityGateEntry which contains array of respected model which is called.
   */
  viewResponse(filter: QualityGateFilter): __Observable<__StrictHttpResponse<QualityGateEntry>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = filter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/qualityGate/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<QualityGateEntry>;
      })
    );
  }
  /**
   * @param filter undefined
   * @return getQualityGateEntry which contains array of respected model which is called.
   */
  view(filter: QualityGateFilter): __Observable<QualityGateEntry> {
    return this.viewResponse(filter).pipe(
      __map(_r => _r.body as QualityGateEntry)
    );
  }

  /**
   * @param filter undefined
   * @return getQualityGateEntry which contains array of respected model which is called.
   */
  viewEntryDetailsResponse(filter: QualityGateDetailsFilter): __Observable<__StrictHttpResponse<QualityGateEntryDetails>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = filter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/qualityGate/view/details`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<QualityGateEntryDetails>;
      })
    );
  }
  /**
   * @param filter undefined
   * @return getQualityGateEntry which contains array of respected model which is called.
   */
  viewEntryDetails(filter: QualityGateDetailsFilter): __Observable<QualityGateEntryDetails> {
    return this.viewEntryDetailsResponse(filter).pipe(
      __map(_r => _r.body as QualityGateEntryDetails)
    );
  }

  /**
   * @param submission undefined
   * @return returns a status about the process
   */
  submitResponse(submission: QualityGateSubmission): __Observable<__StrictHttpResponse<StatusDetail>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = submission;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/qualityGate/submit`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<StatusDetail>;
      })
    );
  }
  /**
   * @param submission undefined
   * @return returns a status about the process
   */
  submit(submission: QualityGateSubmission): __Observable<StatusDetail> {
    return this.submitResponse(submission).pipe(
      __map(_r => _r.body as StatusDetail)
    );
  }

  /**
   * @param submission undefined
   * @return returns a status about the process
   */
  multiSubmissionResponse(submission: QualityGateMultiSubmission): __Observable<__StrictHttpResponse<StatusDetail>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = submission;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/qualityGate/multi-submission`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<StatusDetail>;
      })
    );
  }
  /**
   * @param submission undefined
   * @return returns a status about the process
   */
  multiSubmission(submission: QualityGateMultiSubmission): __Observable<StatusDetail> {
    return this.multiSubmissionResponse(submission).pipe(
      __map(_r => _r.body as StatusDetail)
    );
  }
}

module QualityGateService {
}

export { QualityGateService }
